import * as React from 'react'

import { classList } from 'react-classlist-helper'

import './DatePickerCell.scss'

interface IDatePickerCellProps {
  label: string
  isSelected?: boolean
  isRangeStart?: boolean
  isRangeEnd?: boolean
  isInRange?: boolean
  isHoverStart?: boolean
  isHoverMiddle?: boolean
  isHoverEnd?: boolean
  isCurrent?: boolean
  isDisabled?: boolean
  onClick?: (event?: React.MouseEvent) => void
  onMouseEnter?: () => void
  onMouseLeave?: () => void
  variant?: 'pill'
}

export default class DatePickerCell extends React.PureComponent<IDatePickerCellProps> {
  public render() {
    const {
      label,
      isSelected,
      isRangeStart,
      isRangeEnd,
      isInRange,
      isHoverStart,
      isHoverMiddle,
      isHoverEnd,
      isCurrent,
      isDisabled,
      onClick,
      onMouseEnter,
      onMouseLeave,
      variant = 'pill',
    } = this.props

    return (
      <div
        className={classList({
          'date-picker-cell': true,
          [`variant-${variant}`]: true,
          selected: isSelected,
          'range-start': isRangeStart,
          'range-end': isRangeEnd,
          'in-range': isInRange,
          'hover-start': isHoverStart,
          'hover-middle': isHoverMiddle,
          'hover-end': isHoverEnd,
          current: isCurrent,
          disabled: isDisabled,
        })}
        onClick={isDisabled ? undefined : onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <span className="date-picker-cell-label">{label}</span>
      </div>
    )
  }
}
